
//********************************************************************************************** */
// Product Card Swatch Slider

let initialize_swatch_slider = () => {
  let biggestSwatchSliderHeight = '0'
  let biggestTitleHeight = '0'
  $('.swatch-slider').each((index, item) => {
    let slider = $(item)
    let owl = slider.find('.owl-carousel')
    owl.owlCarousel({
      mouseDrag: false,
      pullDrag: false,
      touchDrag: false,
      dots: false,
      margin: 7,
      // items: 5,
      responsive: {
        0: {
          items: 5
        },
        768: {
          items: 6
        }
      }
    }
    )

    // Go to the next item
    slider.find('.owl-nav-right').click(function () {
      owl.trigger('next.owl.carousel', [300]);
      owl.trigger('next.owl.carousel', [300]);
      owl.trigger('next.owl.carousel', [300]);
      owl.trigger('next.owl.carousel', [300]);
      owl.trigger('next.owl.carousel', [300]);
    })
    // Go to the previous item
    slider.find('.owl-nav-left').click(function () {
      // With optional speed parameter
      // Parameters has to be in square bracket '[]'
      owl.trigger('prev.owl.carousel', [300]);
      owl.trigger('prev.owl.carousel', [300]);
      owl.trigger('prev.owl.carousel', [300]);
      owl.trigger('prev.owl.carousel', [300]);
      owl.trigger('prev.owl.carousel', [300]);
    })

    // let firstOwlItem = $(item).find('.owl-item').first()
    // firstOwlItem.addClass('swatch_selected')
    let height = $(item).height()
    if (height > biggestSwatchSliderHeight) {
      biggestSwatchSliderHeight = height
    }
  })
  $('.swatch-slider').each((index, item) => {
    $(item).css('height', biggestSwatchSliderHeight)
  })
  $('.product-title').each((index, item) => {
    let height = $(item).height()
    if (height > biggestTitleHeight) {
      biggestTitleHeight = height
    }
  })
  $('.product-title').each((index, item) => {
    $(item).css('height', biggestTitleHeight)
  })


  $('.swatch-slider').find('.owl-item').click(function () {
    let self = $(this)
    let title = self.find('.swatch-slider-cell').attr('data-title')
    let subtitle = self.find('.swatch-slider-cell').attr('data-subtitle')
    // let product_card = self.closest('.product-card').find('.product-title').text()
    // console.log(title)
    self.closest('.product-card').find('.product-title').contents()[0].replaceWith(title)
    self.closest('.product-card').find('.product-subtitle').text(subtitle)
    self.closest('.product-card').find('.product_nav_button').addClass('hidden')
    self.closest('.product-card').find('.add_to_cart_button').removeClass('hidden').removeAttr('disabled')
    // console.log(element)
    // $('h1.product-title').text(title)

    self.addClass('swatch_selected').siblings().removeClass('swatch_selected')
    let variant_id = self.find('.swatch-slider-cell').attr('data-id')
    self.closest('.product-card').find('input[name="id"]').attr('value', variant_id)

    let image_url_1 = self.find('.swatch-slider-cell').attr('data-image1')
    let image_url_2 = self.find('.swatch-slider-cell').attr('data-image2')

    self.closest('.product-card').find('.product-card__figure').find('.product-card__image--primary').fadeOut(50)
    self.closest('.product-card').find('.product-card__figure').find('.product-card__image--secondary').fadeOut(50, () => {
      self.closest('.product-card').find('.product-card__figure').find('.product-card__image--primary').attr('src', image_url_1).attr('srcset', image_url_1)
      self.closest('.product-card').find('.product-card__figure').find('.product-card__image--secondary').attr('src', image_url_2).attr('srcset', image_url_2)
      self.closest('.product-card').find('.product-card__figure').find('.product-card__image--primary').fadeIn(130)
      self.closest('.product-card').find('.product-card__figure').find('.product-card__image--secondary').fadeIn(130)
    })
  })
}

$(window).ready(function () {
  initialize_swatch_slider()
});
$(document).on('recommendationsLoaded', function () {
  // Reinitialize the Owl Carousel for the newly loaded content
  initialize_swatch_slider()
});
$(document).on('predictiveSearchResultsLoaded', function () {
  // Reinitialize the Owl Carousel for the newly loaded content
  initialize_swatch_slider()
});

//********************************************************************************************** */
// Swatch Gallery


// $(document).ready(function () {
//   $(document).on('click', '.product .color-swatch', function () {
//     let self = $(this)
//     let title = self.attr('data-title')
//     let variant_id = self.attr('data-variant-id')
//     let subtitle = self.attr('data-subtitle')
//     if($(this).hasClass('is-disabled')) {
//       $('.buy-button-container').addClass('force-hidden')
//     } else {
//       $('.buy-button-container').removeClass('force-hidden')
//     }
//     $('h1.product-title').text(title)

//     $('.product-gallery').fadeOut(250, () => {
//       // $('.product-gallery').addClass('hidden')
//       // $(`.product-gallery.variant-id-${variant_id}`).removeClass('hidden')
//     })
//     $(`.product-gallery.variant-id-${variant_id}`).fadeIn(130)

//     $(`.complementary-products__product-list .recommended-variant`).addClass('hidden')
//     $(`.complementary-products__product-list .variant-id-${variant_id}`).removeClass('hidden')

//     $('.ingredients').addClass('hidden')
//     $(`.ingredients-${variant_id}`).removeClass('hidden')

//     $('.blurb').addClass('hidden')
//     $(`.blurb-${variant_id}`).removeClass('hidden')
//     if(subtitle) {
//       $('.product-subtitle').text(subtitle)
//     }
//     let title_segments = title.split(' | ')
//     $('.variant-picker__option-info span').text(title_segments[title_segments.length - 1])
//   })
// })
//********************************************************************************************** */
// Swatch Gallery / Shade Grid Gallery Sync

$(document).ready(function () {
  function setGalleryDisplay($elements, displayValue) {
    $elements.each(function () {
      this.style.setProperty('display', displayValue, 'important')
      this.style.setProperty('opacity', '1', 'important')
      this.style.setProperty('visibility', 'visible', 'important')
    })
  }

  function showVariantGallery(variantId) {
    if (!variantId) {
      console.warn('Variant ID missing for gallery update')
      return
    }

    let $allGalleries = $('product-gallery.product-gallery[class*="variant-id-"]')
    let $selectedGallery = $(`product-gallery.product-gallery.variant-id-${variantId}`)

    console.log('Gallery update variant:', variantId)
    console.log('All variant galleries:', $allGalleries.length)
    console.log('Selected gallery found:', $selectedGallery.length)

    if (!$allGalleries.length) {
      console.warn('No variant galleries found on page')
      return
    }

    if (!$selectedGallery.length) {
      console.warn('No gallery found for variant:', variantId)
      return
    }

    // Hide all variant galleries
    $allGalleries
      .stop(true, true)
      .addClass('hidden')
      .attr('aria-hidden', 'true')

    setGalleryDisplay($allGalleries, 'none')

    // Show selected variant gallery
    $selectedGallery
      .stop(true, true)
      .removeClass('hidden')
      .removeAttr('hidden')
      .attr('aria-hidden', 'false')

    setGalleryDisplay($selectedGallery, 'inline-block')

    // Reset selected gallery carousel to first image
    let carousel = $selectedGallery.find('scroll-carousel').get(0)

    if (carousel) {
      carousel.scrollLeft = 0

      if (typeof carousel.scrollTo === 'function') {
        carousel.scrollTo({
          left: 0,
          top: 0,
          behavior: 'auto'
        })
      }
    }

    // Reset thumbnails
    $selectedGallery.find('.product-gallery__thumbnail').attr('aria-current', 'false')
    $selectedGallery.find('.product-gallery__thumbnail').first().attr('aria-current', 'true')
  }

  function getVariantIdFromElement($element) {
    return (
      $element.attr('data-variant-id') ||
      $element.attr('data-id') ||
      $element.find('[data-variant-id]').attr('data-variant-id') ||
      $('form[action*="/cart/add"] input[name="id"]').val()
    )
  }

  // Initial load
  setTimeout(function () {
    let initialVariantId =
      $('form[action*="/cart/add"] input[name="id"]').val() ||
      $('[data-shade-grid-swatch].is-selected').attr('data-variant-id') ||
      $('.product .color-swatch[aria-checked="true"], .product .color-swatch.is-selected, .product .color-swatch.active').first().attr('data-variant-id')

    showVariantGallery(initialVariantId)
  }, 300)

  // New draft shade-grid swatch click
  $(document).on('click', '[data-shade-grid-swatch], .shade-grid__swatch', function () {
    let $self = $(this)
    let variantId = getVariantIdFromElement($self)

    setTimeout(function () {
      showVariantGallery(variantId)
    }, 80)
  })

  // Native variant event from shade-grid
  $(document).on('variant:change', 'form[action*="/cart/add"]', function (event) {
    let variantId = event.originalEvent?.detail?.variant?.id

    if (!variantId) {
      variantId = $(this)
        .find('input[name="id"]')
        .val()
    }

    showVariantGallery(variantId)
  })

  // Old/live color swatch support
// Old/live color swatch support
$(document).on('click', '.product .color-swatch', function () {

  let $self = $(this)

  /*
   * --------------------------------------------------
   * MULTI-OPTION PRODUCT SAFETY
   * --------------------------------------------------
   *
   * Example:
   *
   * Option 1: Lip Ammo
   * Option 2: Precision Lip Liner
   *
   * For these products we MUST NOT use the clicked
   * swatch's data-variant-id because it can represent
   * a stale combination.
   *
   * Native variant picker + generic combination resolver
   * below will handle these products.
   */

  let $picker = $self.closest('variant-picker')

  if ($picker.length) {

    const positions = new Set(
      $picker
        .find('input[data-option-position]')
        .map(function () {
          return String(
            $(this).attr('data-option-position')
          )
        })
        .get()
    )

    if (positions.size > 1) {
      return
    }
  }


  /*
   * --------------------------------------------------
   * SINGLE-OPTION PRODUCTS
   * --------------------------------------------------
   *
   * Existing functionality remains unchanged.
   */

  let title = $self.attr('data-title')
  let variantId = getVariantIdFromElement($self)
  let subtitle = $self.attr('data-subtitle')


  setTimeout(function () {

    if ($self.hasClass('is-disabled')) {
      $('.buy-button-container')
        .addClass('force-hidden')
    } else {
      $('.buy-button-container')
        .removeClass('force-hidden')
    }


    if (title) {
      $('h1.product-title').text(title)
    }


    showVariantGallery(variantId)


    $('.complementary-products__product-list .recommended-variant')
      .addClass('hidden')

    $(
      `.complementary-products__product-list .variant-id-${variantId}`
    ).removeClass('hidden')


    $('.ingredients')
      .addClass('hidden')

    $(
      `.ingredients-${variantId}`
    ).removeClass('hidden')


    $('.blurb')
      .addClass('hidden')

    $(
      `.blurb-${variantId}`
    ).removeClass('hidden')


    if (subtitle) {
      $('.product-subtitle').text(subtitle)
    }


    if (title) {

      let title_segments =
        title.split(' | ')

      $('.variant-picker__option-info span')
        .text(
          title_segments[
            title_segments.length - 1
          ]
        )
    }

  }, 80)

})
})

//********************************************************************************************** */
// Variant Categories

$(document).ready(function () {
  $(document).on('click', '.category-wrapper .variant-category', function () {
    let self = $(this)
    // let category = self.text().toLowerCase()
    self.closest('.category-wrapper').find('.variant-category').removeClass('active')
    self.addClass('active')
    let categoryClasses = ''


    $('.category-wrapper').each(function() {
        var activeText = $(this).find('.active').text(); // Find the child with .active class and get its text
        if (activeText && activeText !== 'All') { // Only add if there's text content
          categoryClasses += `.category_${activeText.toLowerCase()}`;
        }
    });

    if(categoryClasses) {
      $('.product .color-swatch').fadeOut(250, () => {
        setTimeout(function() {
          $(`.product .color-swatch${categoryClasses}`).fadeIn(250)
        }, 200);
      })
    } else {
      // $('.product .color-swatch').fadeOut(250, () => {
      //   setTimeout(function() {
      $(`.product .color-swatch`).fadeIn(250);
      //   }, 200);
      // })
    }
  })
})
function applyCategoryselection () {

}
//**********************************************************************************************
// Findation Button Hacks


$(document).ready(function () {
  $(document).on('click', '.findation-link', function () {
    window.Findation.openWidget()
  });
});


$(document).ready(function () {
  $(document).on('click', '.virtual-try-on-button', function () {
    neo({
      client_id: 80,
      configuration_id: 32766
    });
  })
})

//**********************************************************************************************
// Misc Hacks

$(document).ready(function () {
	function updatePromoImageHeight() {
		if ($(window).width() > 768) { // Apply only on desktop (width > 768px)
			$('.featured-collections-carousel__item.promo_image_true').each(function () {
				let productCard = $(this).find('.product-card').first(); // Find first product card inside
				if (productCard.length) {
					let cardHeight = productCard.outerHeight(); // Get its height
					$(this).height(cardHeight); // Set the parent height
				}
			});
		} else {
			// Reset height on mobile to avoid issues
			$('.featured-collections-carousel__item.promo_image_true').css('height', ''); 
		}
	}

	// Run on page load
	updatePromoImageHeight();

	// Run again if window resizes (for responsiveness)
	$(window).resize(updatePromoImageHeight);
});


$(document).on('click', '.swatch-slider .owl-item', function () {
  let self = $(this)
  let cell = self.find('.swatch-slider-cell')

  if (!cell.length) return

  let roundelData = cell.attr('data-roundel')

  let roundelContainer = self
    .closest('.product-card')
    .find('.product-card__roundel_card')

  if (!roundelContainer.length) return

  roundelContainer.empty()

  if (!roundelData || roundelData.trim() === '') {
    roundelContainer.hide()
    return
  }

  roundelContainer.show()

  let badges = roundelData.split('||')

  badges.forEach(function (badge) {
    badge = badge.trim()
    if (badge !== '') {
      roundelContainer.append(
        `<span class="badge badge--custom badge--roundel-text badge--${badge
          .toLowerCase()
          .replace(/\s+/g, '-')}">${badge}</span>`
      )
    }
  })
});


;(function () {

  'use strict';


  // --------------------------------------------------------------------------
  // Avoid registering the resolver twice
  // --------------------------------------------------------------------------

  if (window.SOSUBundleSwatchResolver) {
    window.SOSUBundleSwatchResolver.refresh();
    return;
  }


  // --------------------------------------------------------------------------
  // Internal caches
  // --------------------------------------------------------------------------

  const productSearchCache = new Map();
  const swatchMapCache = new Map();

  let refreshTimer = null;


  // --------------------------------------------------------------------------
  // Helpers
  // --------------------------------------------------------------------------

  function normalize(value) {

    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();

  }


  function cleanProductUrl(url) {

    if (!url) {
      return '';
    }

    try {

      const parsed =
        new URL(
          url,
          window.location.origin
        );

      return parsed.pathname;

    } catch (error) {

      return String(url)
        .split('?')[0];

    }

  }


  // --------------------------------------------------------------------------
  // Shopify Bundles option names normally look like:
  //
  // LIP AMMO (Shade)
  //
  // Precision Lip Liner (Shade)
  //
  // We extract:
  //
  // productTitle = Precision Lip Liner
  // optionName   = Shade
  //
  // If the option isn't in this format we DO NOTHING.
  // --------------------------------------------------------------------------

  function parseBundleOptionLegend(legend) {

    if (!legend) {
      return null;
    }


    const text =
      String(
        legend.textContent || ''
      )
        .replace(/:\s*$/, '')
        .trim();


    if (!text) {
      return null;
    }


    const match =
      text.match(
        /^(.*)\s+\(([^()]*)\)\s*$/
      );


    if (!match) {
      return null;
    }


    const productTitle =
      String(
        match[1] || ''
      ).trim();


    const optionName =
      String(
        match[2] || ''
      ).trim();


    if (
      !productTitle ||
      !optionName
    ) {
      return null;
    }


    return {
      productTitle,
      optionName
    };

  }


  // --------------------------------------------------------------------------
  // Get swatch value text
  //
  // <label class="color-swatch">
  //   <span class="sr-only">Cafe</span>
  // </label>
  // --------------------------------------------------------------------------

  function getSwatchValue(label) {

    if (!label) {
      return '';
    }


    const accessibleLabel =
      label.querySelector(
        '.sr-only'
      );


    if (accessibleLabel) {

      return String(
        accessibleLabel.textContent || ''
      ).trim();

    }


    return String(
      label.textContent || ''
    ).trim();

  }


  // --------------------------------------------------------------------------
  // Find exact product through Shopify Predictive Search
  // --------------------------------------------------------------------------

  async function findProduct(productTitle) {

    const key =
      normalize(
        productTitle
      );


    if (!key) {
      return null;
    }


    if (
      productSearchCache.has(
        key
      )
    ) {

      return productSearchCache.get(
        key
      );

    }


    const promise =
      (async function () {

        try {

          const shopRoot =
            window.Shopify &&
            window.Shopify.routes &&
            window.Shopify.routes.root
              ? window.Shopify.routes.root
              : '/';


          const searchUrl =
            shopRoot +
            'search/suggest.json' +
            '?q=' +
            encodeURIComponent(
              productTitle
            ) +
            '&resources[type]=product' +
            '&resources[limit]=10' +
            '&resources[options][unavailable_products]=last' +
            '&resources[options][fields]=title';


          const response =
            await fetch(
              searchUrl,
              {
                credentials: 'same-origin',
                headers: {
                  Accept: 'application/json'
                }
              }
            );


          if (!response.ok) {

            console.warn(
              '[Bundle Swatches] Product search failed:',
              productTitle,
              response.status
            );

            return null;

          }


          const data =
            await response.json();


          const products =
            data &&
            data.resources &&
            data.resources.results &&
            Array.isArray(
              data.resources.results.products
            )
              ? data.resources.results.products
              : [];


          if (!products.length) {
            return null;
          }


          // --------------------------------------------------------------
          // Exact title match ONLY.
          //
          // This is important because we do not want to accidentally use
          // swatches from a similarly named product.
          // --------------------------------------------------------------

          const exactProduct =
            products.find(
              function (product) {

                return (
                  normalize(
                    product.title
                  ) === key
                );

              }
            );


          if (!exactProduct) {
            return null;
          }


          // --------------------------------------------------------------
          // Never use the current bundle product itself
          // --------------------------------------------------------------

          const currentPath =
            cleanProductUrl(
              window.location.pathname
            );


          const sourcePath =
            cleanProductUrl(
              exactProduct.url
            );


          if (
            currentPath &&
            sourcePath &&
            currentPath === sourcePath
          ) {

            return null;

          }


          return exactProduct;

        } catch (error) {

          console.warn(
            '[Bundle Swatches] Product search error:',
            productTitle,
            error
          );

          return null;

        }

      })();


    productSearchCache.set(
      key,
      promise
    );


    return promise;

  }


  // --------------------------------------------------------------------------
  // Find option group on original component product
  //
  // Bundle:
  //
  // Precision Lip Liner (Shade)
  //
  // Original component:
  //
  // Shade:
  // --------------------------------------------------------------------------

  function findSourceOptionGroup(
    documentObject,
    optionName
  ) {

    if (!documentObject) {
      return null;
    }


    const pickers =
      Array.from(
        documentObject.querySelectorAll(
          'variant-picker'
        )
      );


    if (!pickers.length) {
      return null;
    }


    let picker =
      pickers.find(
        function (item) {

          return (
            item.getAttribute(
              'context'
            ) === 'main_product'
          );

        }
      );


    if (!picker) {
      picker = pickers[0];
    }


    const groups =
      Array.from(
        picker.querySelectorAll(
          '.variant-picker__option'
        )
      );


    const expectedName =
      normalize(
        optionName
      );


    const matchingGroup =
      groups.find(
        function (group) {

          const legend =
            group.querySelector(
              'legend'
            );


          if (!legend) {
            return false;
          }


          const legendText =
            String(
              legend.textContent || ''
            )
              .replace(/:\s*$/, '')
              .trim();


          return (
            normalize(
              legendText
            ) === expectedName
          );

        }
      );


    if (matchingGroup) {
      return matchingGroup;
    }


    // If source product only has one option,
    // it is safe to use that group.

    if (groups.length === 1) {
      return groups[0];
    }


    return null;

  }


  // --------------------------------------------------------------------------
  // Extract swatches from original component product
  // --------------------------------------------------------------------------

  function buildSwatchMap(
    documentObject,
    optionName
  ) {

    const map =
      new Map();


    const sourceGroup =
      findSourceOptionGroup(
        documentObject,
        optionName
      );


    if (sourceGroup) {

      const labels =
        sourceGroup.querySelectorAll(
          'label.color-swatch, a.color-swatch'
        );


      labels.forEach(
        function (label) {

          const optionValue =
            getSwatchValue(
              label
            );


          if (!optionValue) {
            return;
          }


          const background =
            label.style.getPropertyValue(
              '--swatch-background'
            );


          if (!background) {
            return;
          }


          map.set(
            normalize(
              optionValue
            ),
            background.trim()
          );

        }
      );

    }


    // ----------------------------------------------------------------------
    // Fallback support for custom shade-grid products
    // ----------------------------------------------------------------------

    if (!map.size) {

      const shadeGridItems =
        documentObject.querySelectorAll(
          '[data-shade-grid-swatch]'
        );


      shadeGridItems.forEach(
        function (swatch) {

          const optionValue =
            swatch.getAttribute(
              'data-shade-name'
            ) ||
            swatch.getAttribute(
              'title'
            );


          if (!optionValue) {
            return;
          }


          const image =
            swatch.querySelector(
              'img'
            );


          if (image && image.src) {

            map.set(
              normalize(
                optionValue
              ),
              'url("' + image.src + '")'
            );

            return;

          }


          const fill =
            swatch.querySelector(
              '.shade-grid__swatch-fill'
            );


          if (fill) {

            const color =
              fill.style.backgroundColor;


            if (color) {

              map.set(
                normalize(
                  optionValue
                ),
                'linear-gradient(to right, ' +
                  color +
                  ', ' +
                  color +
                  ')'
              );

            }

          }

        }
      );

    }


    return map;

  }


  // --------------------------------------------------------------------------
  // Load original component product page and read its real swatches
  // --------------------------------------------------------------------------

  async function getSourceSwatches(
    productTitle,
    optionName
  ) {

    const cacheKey =
      normalize(
        productTitle
      ) +
      '|' +
      normalize(
        optionName
      );


    if (
      swatchMapCache.has(
        cacheKey
      )
    ) {

      return swatchMapCache.get(
        cacheKey
      );

    }


    const promise =
      (async function () {

        const product =
          await findProduct(
            productTitle
          );


        if (
          !product ||
          !product.url
        ) {

          return new Map();

        }


        try {

          const productUrl =
            cleanProductUrl(
              product.url
            );


          const response =
            await fetch(
              productUrl,
              {
                credentials: 'same-origin',
                headers: {
                  Accept: 'text/html'
                }
              }
            );


          if (!response.ok) {

            console.warn(
              '[Bundle Swatches] Product page fetch failed:',
              productTitle,
              response.status
            );

            return new Map();

          }


          const html =
            await response.text();


          const parsedDocument =
            new DOMParser()
              .parseFromString(
                html,
                'text/html'
              );


          return buildSwatchMap(
            parsedDocument,
            optionName
          );

        } catch (error) {

          console.warn(
            '[Bundle Swatches] Source swatch fetch error:',
            productTitle,
            error
          );

          return new Map();

        }

      })();


    swatchMapCache.set(
      cacheKey,
      promise
    );


    return promise;

  }


async function hydrateOptionGroup(group) {

  if (!group) {
    return false;
  }


  const legend =
    group.querySelector(
      '.variant-picker__option-info legend, legend'
    );


  const bundleInfo =
    parseBundleOptionLegend(
      legend
    );


  if (!bundleInfo) {
    return false;
  }


  const targetSwatches =
    Array.from(
      group.querySelectorAll(
        'label.color-swatch, a.color-swatch'
      )
    );


  if (!targetSwatches.length) {
    return false;
  }


  const sourceSwatches =
    await getSourceSwatches(
      bundleInfo.productTitle,
      bundleInfo.optionName
    );


  if (
    !sourceSwatches ||
    !sourceSwatches.size
  ) {

    return false;
  }


  let updatedCount = 0;


  targetSwatches.forEach(
    function (target) {

      const optionValue =
        getSwatchValue(
          target
        );


      if (!optionValue) {
        return;
      }


      const sourceBackground =
        sourceSwatches.get(
          normalize(
            optionValue
          )
        );


      if (!sourceBackground) {
        return;
      }


      /*
       * ONLY visual background is modified.
       *
       * We do NOT modify:
       *
       * - data-variant-id
       * - input value
       * - checked state
       * - form variant
       * - URL
       * - Add to Cart
       */

      target.style.setProperty(
        '--swatch-background',
        sourceBackground
      );


      target.setAttribute(
        'data-sosu-bundle-swatch-resolved',
        'true'
      );


      updatedCount++;

    }
  );


  /*
   * IMPORTANT:
   *
   * Do not reveal partially corrected swatches.
   *
   * Example:
   *
   * If Precision Lip Liner has 6 swatches,
   * all 6 must be resolved before showing the row.
   */

  const fullyResolved =
    updatedCount === targetSwatches.length;


  if (fullyResolved) {

    group.setAttribute(
      'data-sosu-bundle-swatches-ready',
      'true'
    );

  } else {

    group.removeAttribute(
      'data-sosu-bundle-swatches-ready'
    );

  }


  return fullyResolved;

}


  // --------------------------------------------------------------------------
  // Hydrate one picker
  // --------------------------------------------------------------------------

async function hydratePicker(picker) {

  if (!picker) {
    return;
  }


  /*
   * Only our server-detected bundle pickers.
   *
   * Normal:
   *
   * Color + Size
   *
   * products never reach this code.
   */

  if (
    picker.getAttribute(
      'data-sosu-bundle-picker'
    ) !== 'true'
  ) {

    return;
  }


  const groups =
    Array.from(
      picker.querySelectorAll(
        ':scope > .variant-picker__option'
      )
    );


  if (groups.length <= 1) {
    return;
  }


  /*
   * Option #1 already has the correct advanced
   * swatches with the current bundle structure.
   *
   * The issue is option #2 and above.
   *
   * Therefore don't fetch/modify option #1 at all.
   */

  const groupsToResolve =
    groups.slice(1);


  if (!groupsToResolve.length) {
    return;
  }


  /*
   * Start in protected mode.
   */

  picker.removeAttribute(
    'data-sosu-bundle-fallback'
  );


  /*
   * Safety:
   *
   * In case Shopify search/network fails,
   * don't keep the selector hidden forever.
   */

  const safetyTimer =
    setTimeout(
      function () {

        picker.setAttribute(
          'data-sosu-bundle-fallback',
          'true'
        );

      },
      2000
    );


  try {

    const results =
      await Promise.all(
        groupsToResolve.map(
          function (group) {

            return hydrateOptionGroup(
              group
            );

          }
        )
      );


    const allResolved =
      results.every(
        function (result) {

          return result === true;

        }
      );


    if (allResolved) {

      clearTimeout(
        safetyTimer
      );


      picker.removeAttribute(
        'data-sosu-bundle-fallback'
      );

    }

  } catch (error) {

    console.warn(
      '[Bundle Swatches] Picker hydration failed:',
      error
    );

  }

}


  // --------------------------------------------------------------------------
  // Hydrate all current product pickers
  // --------------------------------------------------------------------------

  async function refresh() {

    const pickers =
      Array.from(
        document.querySelectorAll(
          'variant-picker[data-sosu-bundle-picker="true"]'
        )
      );


    await Promise.all(
      pickers.map(
        hydratePicker
      )
    );

  }


  // --------------------------------------------------------------------------
  // Debounced refresh after native theme rerenders
  // --------------------------------------------------------------------------

  function scheduleRefresh(
    delay
  ) {

    clearTimeout(
      refreshTimer
    );


    refreshTimer =
      setTimeout(
        refresh,
        typeof delay === 'number'
          ? delay
          : 80
      );

  }


  // --------------------------------------------------------------------------
  // Public API / duplicate protection
  // --------------------------------------------------------------------------

  window.SOSUBundleSwatchResolver = {
    refresh: refresh
  };


  // --------------------------------------------------------------------------
  // Initial load
  // --------------------------------------------------------------------------


if (
  document.querySelector(
    'variant-picker[data-sosu-bundle-picker="true"]'
  )
) {

  scheduleRefresh(
    0
  );

} else {

  document.addEventListener(
    'DOMContentLoaded',
    function () {

      scheduleRefresh(
        0
      );

    },
    {
      once: true
    }
  );

}


  // --------------------------------------------------------------------------
  // Native variant changes can rerender variant-picker.
  // Re-apply the visual swatches afterwards.
  // --------------------------------------------------------------------------

  document.addEventListener(
    'variant:change',
    function () {

      scheduleRefresh(
        100
      );

    }
  );


  document.addEventListener(
    'variant:changed',
    function () {

      scheduleRefresh(
        100
      );

    }
  );


  // --------------------------------------------------------------------------
  // Shopify theme editor support
  // --------------------------------------------------------------------------

  document.addEventListener(
    'shopify:section:load',
    function () {

      scheduleRefresh(
        100
      );

    }
  );

})();